import { ITransform } from '../../TableTypes';
export const textCenter: ITransform = () => ({ textCenter: true });
